// Enable OTP SMS Notifications
export const OTP_SMS_NOTIFICATIONS_ENABLE_REQUEST = 'OTP_SMS_NOTIFICATIONS_ENABLE_REQUEST';
export const OTP_SMS_NOTIFICATIONS_ENABLE_SUCCESS = 'OTP_SMS_NOTIFICATIONS_ENABLE_SUCCESS';
export const OTP_SMS_NOTIFICATIONS_ENABLE_FAILURE = 'OTP_SMS_NOTIFICATIONS_ENABLE_FAILURE';

// Disable OTP SMS Notifications
export const OTP_SMS_NOTIFICATIONS_DISABLE_REQUEST = 'OTP_SMS_NOTIFICATIONS_DISABLE_REQUEST';
export const OTP_SMS_NOTIFICATIONS_DISABLE_SUCCESS = 'OTP_SMS_NOTIFICATIONS_DISABLE_SUCCESS';
export const OTP_SMS_NOTIFICATIONS_DISABLE_FAILURE = 'OTP_SMS_NOTIFICATIONS_DISABLE_FAILURE';
